import { render, staticRenderFns } from "./selectedItems.vue?vue&type=template&id=1e43e562&"
import script from "./selectedItems.vue?vue&type=script&lang=js&"
export * from "./selectedItems.vue?vue&type=script&lang=js&"
import style0 from "./selectedItems.vue?vue&type=style&index=0&id=1e43e562&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports